//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[],[],[]];
SPLM.Motion.SpringDamperBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SpringDamperBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SpringDamperBuilder.TranslationalType = Object.freeze({
    "MotionBody" : "MotionBody", "SliderJoint" : "SliderJoint", "CylindricalJoint" : "CylindricalJoint"});

SPLM.Motion.SpringDamperBuilder.RotationalType = Object.freeze({
    "RevoluteJoint" : "RevoluteJoint", "CylindricalJoint" : "CylindricalJoint", "ScrewJoint" : "ScrewJoint", "PlanarJoint" : "PlanarJoint"});

SPLM.Motion.SpringDamperBuilder.ParameterType = Object.freeze({
    "Expression" : "Expression", "Function" : "Function", "Profile2d" : "Profile2d", "Profile3d" : "Profile3d", "ExpressionFunction" : "ExpressionFunction", "ExpressionProfile2d" : "ExpressionProfile2d", "ExpressionProfile3d" : "ExpressionProfile3d"});

SPLM.Motion.SpringDamperBuilder.ApplicationDirectionType = Object.freeze({
    "Bidirectional" : "Bidirectional", "TensionOnly" : "TensionOnly", "CompressionOnly" : "CompressionOnly"});

SPLM.Motion.SpringDamperBuilder.FreeLengthDefinition = Object.freeze({
    "PreloadedAndActuator" : "PreloadedAndActuator", "FreeLengthDirectly" : "FreeLengthDirectly"});

export default SPLM;